import styled from 'styled-components';
import { Box, themedColor } from '@lemonade-hq/cdk';
import { lerp } from '@lemonade-hq/ts-helpers';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';

const Container = styled(Box)`
  position: relative;

  ${MEDIA_QUERIES.upToDesktop`
        transform: scale(0.5);
    `}
`;

const Stroke = styled(Box)`
  height: 11px;
  border-radius: 5px;
  background-color: ${themedColor('primary')};
  position: absolute;
  bottom: -2px;
  right: 0;

  ${MEDIA_QUERIES.upToDesktop`
         height: 8px;
         border-radius: 4px;
    `}
`;

const Pencil = styled.svg`
  transform-origin: 50% 92%;

  ${MEDIA_QUERIES.upToDesktop`
        margin-top: -40px;
    `}
`;

export default function Giveback2020Students({ t, ...props }) {
  const width = lerp(0, 100, t);
  const pencilRotate = lerp(30, -30, t);
  const pencilTranslate = lerp(52, -52, t);
  const pencilStyle = { transform: `rotate(${pencilRotate}deg)` };
  const pencilContainerStyle = { transform: `translateX(${pencilTranslate}%)` };

  return (
    <Container {...props}>
      <Stroke style={{ width: `${width}%` }} />
      <div style={pencilContainerStyle}>
        <Pencil
          style={pencilStyle}
          width="52px"
          height="246px"
          viewBox="0 0 52 246"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-28.000000, -43.000000)">
              <g transform="translate(54.000000, 166.000000) rotate(180.000000) translate(-54.000000, -166.000000) translate(28.000000, 43.000000)">
                <polygon
                  fill="#F7F7F7"
                  points="15.066749 14.6237615 25.6052568 0.808710789 36.2049314 14.6237615 51.4240234 45.6944885 51.4240234 215.536513 2.2339422e-14 215.536513 2.2339422e-14 45.6126589"
                />
                <path
                  d="M5.68434189e-14,206.713029 L51.4240234,206.713029 L51.4240234,219.329988 C51.4240234,233.53034 39.9123637,245.042 25.7120117,245.042 C11.5116598,245.042 5.85824604e-14,233.53034 5.68434189e-14,219.329988 L5.68434189e-14,206.713029 L5.68434189e-14,206.713029 Z"
                  fill="#ECECEC"
                />
                <polygon fill="#ECECEC" points="0 51.266323 51.4240234 51.266323 51.4240234 199.865484 0 199.865484" />
                <polygon
                  fill="#ECECEC"
                  points="39.2061533 20.6745657 51.4240234 45.5365129 0 45.5365129 12.1502211 20.6076602"
                />
                <path
                  d="M31.0131835,4.00282357 L36.2049314,14.5674277 L15.066749,14.6237615 L20.2348053,4.02035651 C21.6866293,1.04162002 25.2783083,-0.196187103 28.2570448,1.25563691 C29.4554499,1.8397347 30.42519,2.80632503 31.0131835,4.00282357 Z"
                  fill="#ECECEC"
                />
              </g>
            </g>
          </g>
        </Pencil>
      </div>
    </Container>
  );
}
